/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'sag-ui-switch',
  template: `
    <div class="flex items-center gap-2">
      <input
        type="switch"
        [id]="id"
        type="checkbox"
        [checked]="checked"
        [disabled]="disabled"
        [required]="required"
        (change)="onChange($event)"
        (click)="click.emit($event)"
        (focus)="focus.emit($event)"
        (blur)="onTouched(); blur.emit($event)"
        sag-ui-switch
      />
      <label [for]="id" sag-ui-switch-label><ng-content></ng-content></label>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
  ],
})
export class SwitchComponent implements ControlValueAccessor, Validator {
  @Input() id = this.randomId();
  @Input() checked = false;
  @Input() disabled = false;
  @Input() required = false;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<Event>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<Event>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() focus = new EventEmitter<Event>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() blur = new EventEmitter<Event>();

  onChangeEvent = (_: any) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.checked = !!obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeEvent = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange(event: Event): void {
    event.stopPropagation();
    const input = event.target as HTMLInputElement;
    this.checked = input.checked;
    this.onChangeEvent(this.checked);
    this.change.emit(event);
  }

  validate(_: AbstractControl): ValidationErrors | null {
    return this.required && !this.checked ? { required: true } : null;
  }

  private randomId(): string {
    return Math.random().toString(36).substring(2);
  }
}
